module.exports = __webpack_public_path__ + "img/portfolio-1.22b6ca67.png";